const navigation = document.getElementById('site-navigation');
const hamburger = document.getElementById('site-navigation-button');
const navigationContent = document.getElementById('site-navigation-content');

const hamburgerActiveClassName = 'is-active';
const navigationActiveClassName = 'navigation--active';
const navigationContentActiveClassName = 'navigation__content--active';

if (hamburger) {
    hamburger.addEventListener('click', e => {
        const isActive = navigation.classList.contains(navigationActiveClassName);
        if (isActive) {
            navigation.classList.remove(navigationActiveClassName);
            navigationContent.classList.remove(navigationContentActiveClassName);
            hamburger.classList.remove(hamburgerActiveClassName);
            hamburger.setAttribute('aria-expanded', 'false');
        } else {
            navigation.classList.add(navigationActiveClassName);
            navigationContent.classList.add(navigationContentActiveClassName);
            hamburger.classList.add(hamburgerActiveClassName);
            hamburger.setAttribute('aria-expanded', 'true');
        }
    });
}


const menues = Array.from(document.querySelectorAll('.menu'));
const menuItemActiveClass = 'menu__item--hover';

menues.forEach(menu => {
    const menuItemsWithFlyout = Array.from(menu.querySelectorAll('.menu__item')).filter(item => item.querySelector('.flyout') !== null);
    menuItemsWithFlyout.forEach(item => {
        const link = item.querySelector('.menu__link');

        // show flyout on click if it isn't open already (mostly for touch devices)
        link.addEventListener('click', e => {
            // for fine pointers with hover states (non-touch devices), let the click go through
            if (window.matchMedia('(pointer: fine)').matches) return;

            const isActive = item.classList.contains(menuItemActiveClass);
            if (isActive) {
                // let the click go through
            } else {
                // activate the currently targeted item
                item.classList.add(menuItemActiveClass);
                // prevent the navigation
                e.preventDefault();
            }
        });
    });
});
